import React from "react";
import { Container, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

export default function UserList({ users }) {
    return (
        <Container>
            <div className="user-cards-grid">
                {users &&
                    users.map((item, i) => {
                        return (
                            <div key={i} className="user-card">
                                <div className="user-card-content">
                                    <img
                                        src={item.avatar_url}
                                        alt={item.login}
                                        className="user-card-avatar"
                                    />
                                    <div className="user-card-name">{item.login}</div>
                                    <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>
                                        {item.login}
                                    </p>
                                    <Button
                                        fluid
                                        content="View Profile"
                                        className="user-card-btn"
                                        as={Link}
                                        to={`/${item.login}`}
                                    />
                                </div>
                            </div>
                        );
                    })}
            </div>
        </Container>
    );
}
